import { render } from "./DecorationMenu.vue?vue&type=template&id=f8d46546"
import script from "./DecorationMenu.vue?vue&type=script&lang=js"
export * from "./DecorationMenu.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__